import { useState } from 'react'

export interface DeleteCompanyResponse {
  message: string
}

export interface UseDeleteCompanyResult {
  deleteCompany: (companyId: string) => Promise<DeleteCompanyResponse>
  loading: boolean
  error: string | null
}

export function useDeleteCompany(): UseDeleteCompanyResult {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const deleteCompany = async (companyId: string): Promise<DeleteCompanyResponse> => {
    try {
      setLoading(true)
      setError(null)

      // Get auth token
      const token = localStorage.getItem('token')
      if (!token) {
        throw new Error('No authentication token found')
      }

      const response = await fetch(`/api/admin/companies/${companyId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Unknown error' }))
        throw new Error(errorData.error || `Failed to delete company (${response.status})`)
      }

      const data: DeleteCompanyResponse = await response.json()
      return data
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to delete company'
      setError(errorMessage)
      console.error('Error deleting company:', err)
      throw err
    } finally {
      setLoading(false)
    }
  }

  return {
    deleteCompany,
    loading,
    error
  }
}
